import { UserProvider } from './context/UserContext';
import AppRouter from './router/AppRouter';
import "katex/dist/katex.min.css";

export default function App() {
  return (
    <UserProvider>
      <AppRouter />
    </UserProvider>
  );
}
